// Configuración de la API
export const API_CONFIG = {
  // Prefer the environment variable `REACT_APP_API_URL` when provided.
  // In development prefer localhost to test against a local backend.
  // Fallback to Cloud Run in production when no env var is provided.
  // Normalize provided REACT_APP_API_URL: if the env var is set but does not
  // end with '/api', append '/api' so callers may concatenate paths as before.
  BASE_URL: (() => {
    const envUrl = process.env.REACT_APP_API_URL;
    if (envUrl && typeof envUrl === 'string') {
      return envUrl.endsWith('/api') ? envUrl : `${envUrl.replace(/\/$/, '')}/api`;
    }
    if (process.env.REACT_APP_ENV === 'development' || process.env.NODE_ENV === 'development') {
      return 'http://localhost:3000/api';
    }
    return 'https://zc-backend-552991655746.southamerica-west1.run.app/api';
  })(),
  // Fallback directo a Cloud Run cuando BASE_URL devuelve HTML (CDN sirviendo SPA)
  FALLBACK_BASE_URL: 'https://zc-backend-552991655746.southamerica-west1.run.app/api',
  TIMEOUT: 10000, // Timeout reducido a 10 segundos para detectar problemas más rápido
  RETRY_ATTEMPTS: 2, // Reducir intentos para fallback más rápido
  DEMO_MODE: false, // Solo datos reales del backend
};

// Configuración de CORS
export const CORS_CONFIG = {
  credentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
};

// Configuración de autenticación
export const AUTH_CONFIG = {
  TOKEN_KEY: 'token',
  USER_KEY: 'user',
  REFRESH_INTERVAL: 5 * 60 * 1000, // 5 minutos
  // Duración de sesión (minutos). Configurable vía REACT_APP_SESSION_MINUTES
  SESSION_DURATION_MINUTES: parseInt(process.env.REACT_APP_SESSION_MINUTES || '240', 10),
};


// Configuración de archivos
export const FILE_CONFIG = {
  // El tope real no lo pone multer sino Cloud Run: rechaza cualquier request HTTP/1
  // de más de 32 MiB con un 413 de Google Frontend SIN cabeceras CORS, y el navegador
  // lo reporta como "blocked by CORS policy". 30 MiB deja margen para el multipart.
  MAX_SIZE: 30 * 1024 * 1024,
  MAX_SIZE_MB: 30,
  // Por encima de MAX_SIZE se sube por trozos (apiService.subirArchivoPorTrozos). Hoy solo
  // lo hace la subida de documentos de empresa en Acreditación. Igual al MAXIMO del backend.
  MAX_SIZE_POR_TROZOS: 300 * 1024 * 1024,
  MAX_SIZE_POR_TROZOS_MB: 300,
  UPLOAD_TIMEOUT: 120000, // 2 minutos para uploads grandes
  // Ver o descargar un documento baja el archivo entero como blob. Con el TIMEOUT general
  // (10 s) un documento de empresa grande (hasta 300 MiB) se cortaba con "timeout of 10000ms
  // exceeded" aunque el backend lo estuviera enviando bien.
  DOWNLOAD_TIMEOUT: 10 * 60 * 1000,
  SUPPORTED_TYPES: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'image/jpeg',
    'image/png',
    'image/gif',
    'text/plain',
    'application/zip',
    'application/x-rar-compressed'
  ],
  SUPPORTED_EXTENSIONS: [
    '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx',
    '.jpg', '.jpeg', '.png', '.gif', '.txt', '.zip', '.rar'
  ]
};
